<script>
import bem from '@/utils/bem';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import { mapActions, mapGetters } from 'vuex';
import CreateNewZipCode from '@/components/modals/Create-new-zip-code.vue';
import createDebounce from '@/utils/debounce';
import { SearchOutlined } from '@ant-design/icons-vue';
import columns from './columns';

const b = bem('zip-codes-page');

export default {
  data() {
    return {
      title: 'Zip Codes',
      columns: columns(),
      showCreate: false,
      searchText: '',
      zipCodes: [],
    };
  },
  components: {
    CreateNewZipCode,
    PageHeader,
    SearchOutlined,
  },
  methods: {
    createDebounce,
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getZipCodesAction: 'zipCodes/getZipCodes',
      updateZipCodeAction: 'zipCodes/updateZipCode',
      deleteZipCodeAction: 'zipCodes/deleteZipCode',
    }),
    openCreateWindow() {
      this.showCreate = true;
    },
    getZipCodes() {
      this.getZipCodesAction();
    },
    changeZipCode(name, localPickUp) {
      this.updateZipCodeAction({
        name,
        localPickUp,
      });
    },
    deleteZipCode(id) {
      this.deleteZipCodeAction(id);
    },
  },
  mounted() {
    this.getZipCodes();
    this.zipCodes = this.sortedZipCodes;
  },
  computed: {
    ...mapGetters({
      sortedZipCodes: 'zipCodes/sortedZipCodes',
    }),
  },
  watch: {
    sortedZipCodes(newV) {
      this.zipCodes = newV;
    },
    searchText(newV) {
      if (newV) {
        this.zipCodes = this.sortedZipCodes.filter((item) => item.zip.startsWith(newV));
      } else {
        this.zipCodes = this.sortedZipCodes;
      }
    },
  },
};

</script>

<template>
  <PageHeader :title="title"/>
  <div :class="b()">
    <div :class="b('top-wrapper')">
      <a-input
        placeholder="Search by zip code..."
        style="max-width: 250px"
        v-model:value="searchText"
      >
        <template #suffix>
          <search-outlined />
        </template>
      </a-input>
      <a-button
        type="primary"
        html-type="button"
        @click="openCreateWindow"
      >
        Create new zip code
      </a-button>
    </div>
    <div v-if="showCreate">
      <CreateNewZipCode v-model:show="showCreate" />
    </div>
    <div :class="b('table')">
      <a-table
        :columns="columns"
        :data-source="zipCodes"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'localPickUp'">
            <div >
              <a-switch
                :checked="text"
                checked-children="Yes"
                un-checked-children="No"
                @change="changeZipCode(record.zip, !text)"
              ></a-switch>
            </div>
          </template>
          <template v-else-if="column.dataIndex === 'delete'">
            <div>
              <a-popconfirm title="Sure to delete?" @confirm="deleteZipCode(record.id)">
                <a-button type="primary" html-type="button" danger>
                  Delete
                </a-button>
              </a-popconfirm>
            </div>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<style scoped lang="scss">
.zip-codes-page {
  margin: 0 20px;
  &__top-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
  }
}
</style>
